import { render, staticRenderFns } from "./dataCreateForm.vue?vue&type=template&id=6a403142"
import script from "./dataCreateForm.vue?vue&type=script&lang=js"
export * from "./dataCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports